import { render, staticRenderFns } from "./add_delivery.vue?vue&type=template&id=292aaa70&scoped=true"
import script from "./add_delivery.vue?vue&type=script&lang=js"
export * from "./add_delivery.vue?vue&type=script&lang=js"
import style0 from "./add_delivery.vue?vue&type=style&index=0&id=292aaa70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292aaa70",
  null
  
)

export default component.exports